import { readYodleeProfile } from '../actions';
import { updateSingleProfile } from './helpers';

type Action = {
  type?: string;
  payload?: any;
  meta?: Record<string, any>;
};

const reducer = (state: Record<string, any> = {}, action: Action = {}) => {
  const { payload } = action;

  switch (action.type) {
    case readYodleeProfile.SUCCESS_TYPE: {
      const { profileType, data } = payload;
      return updateSingleProfile(state, profileType, data);
    }

    default: {
      return state;
    }
  }
};

export default reducer;
